import { Box, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { PieChart } from '@mui/x-charts/PieChart';
import { ChartContainer } from '@mui/x-charts/ChartContainer';
import { BarPlot, BarChart } from '@mui/x-charts/BarChart';
import { fetchVerResultadosEncuesta, selectIsLoading, selectResultados } from '../../redux/Encuestas/EncuestasSlice';
import { Encabezado } from '../../Components/Encabezado/Encabezado';
import Loading from '../../Components/Modals/Loading/Loader';

export const Resultados = () => {
    const location = useLocation();
    const encuesta = location.state;

    const dispatch = useDispatch();
    const resultados = useSelector(selectResultados);
    const isLoading = useSelector(selectIsLoading);


    useEffect(() => {
        dispatch(fetchVerResultadosEncuesta(encuesta.encuestaId));
    }, []);

    const dataBarChart = resultados?.participantes?.map(resultado => resultado.cantidadVotos ?? 0);
    const labelsBarChart = resultados?.participantes?.map(resultado => resultado.nombres.split(" ")[0] ?? "");

    return (
        <Encabezado title={"Resultados de la encuesta"}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 4 }}>
                {resultados?.participantes?.length > 0 ? (
                    <>
                        <Typography variant='h5'>
                            Los 5 participantes más votados
                        </Typography>
                        <PieChart
                            margin={{ top: 50, bottom: 50, left: 50, right: 50 }}
                            series={[
                                {
                                    data: (() => {
                                        const top5 = resultados.participantes.slice(0, 5).map((p, index) => ({
                                            id: index,
                                            value: p.cantidadVotos ?? 0,
                                            label: (p.nombres.split(" ")[0] + ' ' + p.apellidos.split(" ")[0]) ?? "",
                                        }));
                                        const otrosVotos = resultados.participantes.slice(5).reduce((acc, p) => acc + (p.cantidadVotos ?? 0), 0);

                                        if (otrosVotos > 0) {
                                            top5.push({
                                                id: 5,
                                                value: otrosVotos,
                                                label: "Otros participantes",
                                            });
                                        }

                                        return top5;
                                    })(),
                                },
                            ]}
                            width={1000}
                            height={300}
                            slotProps={{
                                legend: {
                                    direction: 'row',
                                    position: { vertical: 'top' },
                                    padding: 10,
                                },
                            }}
                        />
                        <Typography variant='h5'>
                            Resultados generales
                        </Typography>
                        <Box>
                            <BarChart
                                width={1200}
                                height={300}
                                series={[
                                    { data: dataBarChart, label: 'Cantidad de votos', id: 'pvId', color: '#003876' },
                                ]}
                                xAxis={[{
                                    data: labelsBarChart, scaleType: 'band',
                                    tickLabelStyle: {
                                        angle: -25,
                                        textAnchor: 'end',
                                        fontSize: 11,
                                    },
                                }]}
                            />
                        </Box>


                    </>
                ) : (
                    <Typography variant="h6" color="textSecondary">
                        No hay datos disponibles.
                    </Typography>
                )}
                <Loading open={isLoading} />
            </Box>
        </Encabezado>
    );
};
